import { render, staticRenderFns } from "./AccessControl.vue?vue&type=template&id=51d9279f&scoped=true&lang=pug&"
import script from "./AccessControl.vue?vue&type=script&lang=js&"
export * from "./AccessControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d9279f",
  null
  
)

export default component.exports